import { dialerClient } from "@/api/index";
import { DialReq } from "@/pbjs/xcommon/dialer_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { localGet, setMetaData, timeFormat, whetherSetParam } from "@/utils";
// lin 获取工单分配支持的所有的参数数据
interface Options {
  phoneNumber: string;
  supplier: number;
  orderId: string;
  ticketType: number;
  ticketId: number;
  opuId: number;
  assignuId: number;
  dialway:number;
}
export function makeDial(arg: Options) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialReq();
      request.setCommonin(setCommon());
      request.setAssignid(arg.assignuId);
      request.setPhonenumber(arg.phoneNumber);
      request.setSupplier(arg.supplier);
      request.setOrderid(arg.orderId);
      request.setTickettype(arg.ticketType);
      request.setTicketid(arg.ticketId);
      request.setOpuid(arg.opuId);
      request.setDialway(arg.dialway);
      dialerClient.makeDial(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
